import {
  toApiOwnerType,
  toApiStatus,
  toUiOwnerType,
  toUiStatus,
} from './_helpers';

/** API EquipmentAsset ↔ UI equipment asset fields. */

export function equipmentFromApi(row) {
  if (!row) return null;
  const typeName =
    row.equipmentType?.name ||
    row.equipmentType?.code ||
    row.equipmentType ||
    '';
  return {
    id: row.id,
    assetId: row.code ?? '',
    ownerType: toUiOwnerType(row.ownerType),
    peopleId: row.villager?.code ?? '',
    peopleDbId: row.villagerId ?? row.villager?.id ?? null,
    peopleName:
      row.ownerName ||
      row.villager?.fullName ||
      row.villager?.name ||
      '',
    vendorId: row.vendor?.code ?? '',
    vendorDbId: row.vendorId ?? null,
    vendorName: row.vendor?.tradeName || row.ownerName || '',
    villageId: row.village?.code ?? row.villageId ?? '',
    villageDbId: row.villageId ?? null,
    villageName: row.villageName || row.village?.name || '',
    equipmentTypeId: row.equipmentTypeId ?? row.equipmentType?.id ?? null,
    equipmentType: typeof typeName === 'string' ? typeName : '',
    equipmentDescription: row.description ?? '',
    remarks: row.remarks ?? '',
    vehicleClass: row.vehicleClass ?? '',
    manufacturer: row.manufacturer ?? '',
    model: row.model ?? '',
    variant: row.variant ?? '',
    capacity: row.capacity ?? '',
    capacityUom: row.capacityUom ?? '',
    yom: row.yom ?? '',
    regNo: row.regNo ?? '',
    chassisNumber: row.chassisNumber ?? '',
    engineNumber: row.engineNumber ?? '',
    dateOfReg: row.dateOfReg ?? '',
    regValidUpto: row.regValidUpto ?? '',
    nameAsPerRc: row.nameAsPerRc ?? '',
    sonOfWifeOf: row.sonOfWifeOf ?? '',
    color: row.color ?? '',
    fuel: row.fuel ?? '',
    pucDate: row.pucDate ?? '',
    pucValidUpto: row.pucValidUpto ?? '',
    insuranceIssueDate: row.insuranceIssueDate ?? '',
    insuranceValidUpto: row.insuranceValidUpto ?? '',
    taxValidUpto: row.taxValidUpto ?? '',
    fitnessValidUpto: row.fitnessValidUpto ?? '',
    status: toUiStatus(row.kycStatus),
    operationalStatus: toUiStatus(row.operationalStatus),
    documents: [],
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function equipmentToApi(ui) {
  if (!ui) return null;
  return {
    ownerType: toApiOwnerType(ui.ownerType),
    villagerId: ui.peopleDbId ?? null,
    vendorId: ui.vendorDbId ?? null,
    villageId: ui.villageDbId ?? null,
    equipmentTypeId: ui.equipmentTypeId,
    description: ui.equipmentDescription || null,
    remarks: ui.remarks || null,
    vehicleClass: ui.vehicleClass || null,
    manufacturer: ui.manufacturer || null,
    model: ui.model || null,
    variant: ui.variant || null,
    capacity: ui.capacity || null,
    capacityUom: ui.capacityUom || null,
    yom: ui.yom || null,
    regNo: ui.regNo || null,
    chassisNumber: ui.chassisNumber || null,
    engineNumber: ui.engineNumber || null,
    dateOfReg: ui.dateOfReg || null,
    regValidUpto: ui.regValidUpto || null,
    nameAsPerRc: ui.nameAsPerRc || null,
    sonOfWifeOf: ui.sonOfWifeOf || null,
    color: ui.color || null,
    fuel: ui.fuel || null,
    pucDate: ui.pucDate || null,
    pucValidUpto: ui.pucValidUpto || null,
    insuranceIssueDate: ui.insuranceIssueDate || null,
    insuranceValidUpto: ui.insuranceValidUpto || null,
    taxValidUpto: ui.taxValidUpto || null,
    fitnessValidUpto: ui.fitnessValidUpto || null,
    kycStatus: ui.status ? toApiStatus(ui.status) : undefined,
    operationalStatus: ui.operationalStatus
      ? toApiStatus(ui.operationalStatus)
      : undefined,
    isActive: ui.active !== false,
  };
}
